import Block from '@/components/Cart/modal/Block/Block';
import COLORS from '@/constants/colors';
import TableLayout from '@/layouts/TableLayout/TableLayout';
import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { forwardRef } from 'react';
import { CloseModalHandler } from '../CartModal';
import { DRAFT_ORDER_CONTAINER_TO_PRINT } from '../ModalBody';
import { TotalTicket } from '../TotalTicket';
import { ProductLine } from './ProductLine';
import { SellerTicket } from './SellerTicket';
import { useViewCartBodyViewController } from './ViewCartBodyViewController';

export const ViewCartBody = forwardRef<CloseModalHandler, object>(
  function ViewCartBodyInner(_props, ref) {
    const { uiState } = useViewCartBodyViewController(ref);

    return (
      <Stack id={DRAFT_ORDER_CONTAINER_TO_PRINT}>
        <Block>
          <Stack direction={'row'} spacing={'8px'}>
            <span
              style={{
                fontWeight: 600,
                color: COLORS.olive,
                fontSize: '14px',
              }}
            >
              Comprador:
            </span>
            <span>{uiState?.buyer.name}</span>
          </Stack>
        </Block>
        <TableLayout
          body={
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={cellStyle}>Vendedor</TableCell>
                  <TableCell sx={cellStyle}>Producto</TableCell>
                  <TableCell sx={cellStyle}>Cantidad</TableCell>
                  <TableCell sx={cellStyle}>Nuevo precio</TableCell>
                  <TableCell sx={cellStyle}>Total</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {uiState.products.map((product) => (
                  <ProductLine key={product.id} product={product} />
                ))}
              </TableBody>
            </Table>
          }
        />

        <Block
          sx={{
            my: ' 16px',
            padding: '28px',
            position: 'relative',
          }}
        >
          {Boolean(uiState.products.length) && (
            <>
              {' '}
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 600,
                  fontSize: '12px',
                  color: COLORS.olive,
                  marginBottom: '12px',
                }}
              >
                Envíos
              </Typography>
              <Stack gap="16px">
                {uiState.sellers.map((sellerTicket) => (
                  <Box
                    key={sellerTicket.id}
                    sx={{
                      backgroundColor: COLORS.white,
                      border: `1px solid ${COLORS.gray_200}`,
                      borderRadius: '12px',
                      padding: '16px',
                    }}
                  >
                    <SellerTicket
                      key={sellerTicket.id}
                      sellerTicketUi={sellerTicket}
                    />
                  </Box>
                ))}
                <TotalTicket totalTicket={uiState.total} />
              </Stack>
            </>
          )}
        </Block>
      </Stack>
    );
  }
);

const cellStyle = {
  fontWeight: 600,
  color: COLORS.olive,
  borderBottom: 'none',
  fontSize: '14px',
};
